export const POLICY_UPGRADE_REQUIRED_POLLING_INTERVAL = 20 * 1000; // 20 seconds
export const DEFAULT_POLICY_UPGRADE_STATUS_POLLING_INTERVAL = 60 * 60 * 1000; // 1 hour
export const POLICY_POLLING_INTERVAL = 30 * 1000; // 30 seconds
export const POLICIES_POLLING_INTERVAL = 30 * 1000; // 30 seconds
